import { Column } from '../../components/Layout/Column'
import { ThemedHeroImage } from '../../components/ThemedHeroImage'
import { Body, Image, Spacer } from '@spritz-finance/ui'
import { Loader } from '../../components/Loader'
import React from 'react'

export const AwaitingVerificationCompletionCard = () => {
    return (
        <Column align="center">
            <ThemedHeroImage>
                <Image.BillHistory height={75} />
            </ThemedHeroImage>
            <Spacer height={16} />
            <Body.SmBold>Verifying your identity...</Body.SmBold>
            <Spacer height={16} />
            <Body.Med size={14} align="center">
                We are currently verifying the information that you have given us. This should only
                take a moment
            </Body.Med>
            <Spacer height={8} />
            <Loader />
        </Column>
    )
}
